export function checkIfS2LoadedInsideAgent(parent?: string) {
    try {
        if (parent && parent === 'VoxcoAgent') {
            return true;
        }
    } catch (error) {
        // eslint-disable-next-line no-console
        console.error("Error accessing getCookie method on window.parent:", error);
        return false;
    }
    return false;
}

function getKeyCombination(event: KeyboardEvent) {
    const keys = [];
    if (event.ctrlKey) keys.push("ctrl");
    if (event.altKey) keys.push("alt");
    if (event.shiftKey) keys.push("shift");

    keys.push(event.key.toLowerCase());

    return keys.join("+");
}

export function addVoxcoAgentListener(parent?: string) {
    if (checkIfS2LoadedInsideAgent(parent)) {
        window.addEventListener("keydown", (event: KeyboardEvent) => {
            // Ignore keypress if agent is typing in below fields
            const isInputFieldType = ["INPUT", "TEXTAREA", "SELECT"].includes(
                document.activeElement.tagName,
            );

            if (!isInputFieldType) {
                window.parent.postMessage(
                    { type: "voxcoagentshortcut", key: getKeyCombination(event) },
                    "*",
                );
            }
        });

        window.addEventListener("click", () => {
            window.parent.postMessage({ type: "voxcoagents2clickeventhandler" }, "*");
        });
    }
}
